import { ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Select2, Select2Data } from 'ng-select2-component';
import { ChatService, getChatErrorDetail } from '../../../services/chat.service';
import { ChatRealtimeService } from '../../../services/chat-realtime.service';
import { Helpers } from '../../../helpers/helpers';
import { ChatRoomDTO } from '../../../models/chat-room-dto';

@Component({
  selector: 'app-chat-create-room-modal',
  standalone: true,
  imports: [FormsModule, Select2],
  templateUrl: './chat-create-room-modal.component.html',
  styleUrl: './chat-create-room-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChatCreateRoomModalComponent implements OnInit {
  activeModal = inject(NgbActiveModal);
  private chatService = inject(ChatService);
  private chatRealtimeService = inject(ChatRealtimeService);
  private helpers = inject(Helpers);
  private cdr = inject(ChangeDetectorRef);
  private destroyRef = inject(DestroyRef);

  userSelectData: Select2Data = [];
  selectedUserIds: string[] = [];
  title = '';
  saving = false;

  ngOnInit(): void {
    this.chatService.getSelectableUsers().pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: users => {
        this.chatRealtimeService.seedOnlineStatus(users);
        // Propiedad plana, no getter: select2 compara por referencia y perdería el hover si se recalculase.
        this.userSelectData = users.map(u => ({
          value: u.IdUser,
          label: `${u.IsOnline ? '🟢' : '🔴'} ${u.Role ? `${u.Role} - ${u.Name}` : u.Name}`
        }));
        this.cdr.detectChanges();
      },
      error: err => this.helpers.showError('Error al recuperar los usuarios de la instalación', getChatErrorDetail(err))
    });
  }

  create(): void {
    if (this.selectedUserIds.length === 0 || this.saving) return;

    this.saving = true;
    this.chatService.createRoom({ UserIds: this.selectedUserIds, Title: this.title || undefined }).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: (room: ChatRoomDTO) => this.activeModal.close(room),
      error: err => {
        this.saving = false;
        this.helpers.showError('Error al crear la sala', getChatErrorDetail(err));
        this.cdr.detectChanges();
      }
    });
  }

  close(): void {
    this.activeModal.dismiss();
  }
}
